import { useEffect, useState, useCallback } from "react";
import { CreditCard, Loader2 } from "lucide-react";
import { adminApi } from "@/lib/adminApi";
import { StatusBadge } from "@/components/admin/_shared";
import AdminCustomerActions from "@/components/admin/AdminCustomerActions";

const PLAN_LABEL = { starter: "Starter", professional: "Professional", business: "Business" };

export default function AdminSubscriptions() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    adminApi.get("/admin/customers").then((r) => {
      const cs = r.data.customers || r.data.items || (Array.isArray(r.data) ? r.data : []);
      setRows(cs); setLoading(false);
    }).catch(() => setLoading(false));
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="admin-subscriptions-view">
      <h1 className="font-heading text-2xl font-bold tracking-tight flex items-center gap-2"><CreditCard className="h-6 w-6 text-blue-600" /> Subscriptions</h1>
      <p className="text-slate-500 mt-1">Manage plans, trials, usage, discounts and credits. Every change is audit-logged.</p>

      <div className="mt-4 rounded-2xl border border-slate-200 bg-white overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wide">
            <tr>
              <th className="text-left font-semibold px-4 py-3">Business</th>
              <th className="text-left font-semibold px-4 py-3">Plan</th>
              <th className="text-left font-semibold px-4 py-3">Status</th>
              <th className="text-left font-semibold px-4 py-3">AI minutes</th>
              <th className="text-right font-semibold px-4 py-3">Manage</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {loading && <tr><td colSpan={5} className="py-12 text-center text-slate-400"><Loader2 className="h-5 w-5 animate-spin inline" /></td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan={5} className="py-12 text-center text-slate-400">No customers yet.</td></tr>}
            {!loading && rows.map((c) => (
              <tr key={c.user_id || c.id} data-testid="subscription-row" className="hover:bg-slate-50">
                <td className="px-4 py-3 font-medium text-slate-800">{c.business_name || c.name || c.email}</td>
                <td className="px-4 py-3">{PLAN_LABEL[c.plan] || c.plan || "—"}</td>
                <td className="px-4 py-3"><StatusBadge status={c.status} /></td>
                <td className="px-4 py-3 text-slate-600">{c.minutes_used ?? 0}{c.minutes_limit ? ` / ${c.minutes_limit}` : ""}</td>
                <td className="px-4 py-3 text-right"><AdminCustomerActions customer={c} onDone={load} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
